import { useState } from 'react';
import { cn } from '@/lib/utils';

const Projects = () => {
  const [activeFilter, setActiveFilter] = useState('all');
  
  const categories = [
    { id: 'all', name: 'All' },
    { id: 'web', name: 'Web Apps' },
    { id: 'mobile', name: 'Mobile' },
    { id: 'game', name: 'Games' }
  ];
  
  const projects = [
    {
      id: 1,
      title: 'Pixel Weather App',
      description: 'A weather application with pixel art animations for different weather conditions.',
      category: 'web',
      image: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='240' height='180' viewBox='0 0 240 180'%3E%3Crect width='240' height='180' fill='%233da6a6'/%3E%3Ccircle cx='60' cy='60' r='32' fill='%23f4cf4c'/%3E%3Crect x='20' y='120' width='200' height='40' fill='%235ecc5e'/%3E%3Crect x='160' y='40' width='40' height='20' fill='%23ffffff'/%3E%3Crect x='150' y='60' width='60' height='20' fill='%23ffffff'/%3E%3C/svg%3E",
      tags: ['React', 'TypeScript', 'Tailwind CSS'],
      link: '#'
    },
    {
      id: 2,
      title: 'Retro Task Manager',
      description: 'A productivity application with a nostalgic 8-bit interface.',
      category: 'web',
      image: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='240' height='180' viewBox='0 0 240 180'%3E%3Crect width='240' height='180' fill='%232d5d3b'/%3E%3Crect x='20' y='20' width='200' height='30' fill='%23f5f5f5'/%3E%3Crect x='20' y='60' width='200' height='20' fill='%23f5f5f5'/%3E%3Crect x='20' y='90' width='200' height='20' fill='%23f5f5f5'/%3E%3Crect x='20' y='120' width='200' height='20' fill='%23f5f5f5'/%3E%3Crect x='190' y='60' width='20' height='20' fill='%23e05c5c'/%3E%3Crect x='190' y='90' width='20' height='20' fill='%23f4cf4c'/%3E%3Crect x='190' y='120' width='20' height='20' fill='%235ecc5e'/%3E%3C/svg%3E",
      tags: ['Vue.js', 'Firebase', 'CSS Animation'],
      link: '#'
    },
    {
      id: 3,
      title: 'Pixel Platformer',
      description: 'A 2D platformer game with handcrafted pixel art environments and characters.',
      category: 'game',
      image: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='240' height='180' viewBox='0 0 240 180'%3E%3Crect width='240' height='180' fill='%231e3a2b'/%3E%3Crect x='0' y='140' width='240' height='40' fill='%235ecc5e'/%3E%3Crect x='120' y='100' width='40' height='40' fill='%23cf56a1'/%3E%3Crect x='40' y='100' width='20' height='20' fill='%23f4cf4c'/%3E%3Crect x='180' y='120' width='20' height='20' fill='%23f4cf4c'/%3E%3Ccircle cx='40' cy='40' r='20' fill='%233da6a6'/%3E%3C/svg%3E",
      tags: ['Unity', 'C#', 'Pixel Art'],
      link: '#'
    },
    {
      id: 4,
      title: 'Crypto Tracker',
      description: 'A cryptocurrency price tracking app with pixel art visualizations.',
      category: 'mobile',
      image: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='240' height='180' viewBox='0 0 240 180'%3E%3Crect width='240' height='180' fill='%232a2a2a'/%3E%3Cpath d='M40,40 L200,40 L200,140 L40,140 Z' fill='%233da6a6'/%3E%3Cpath d='M60,100 L80,80 L100,110 L120,70 L140,90 L160,60 L180,120' stroke='%23f4cf4c' stroke-width='4' fill='none'/%3E%3Ccircle cx='60' cy='100' r='4' fill='%23f4cf4c'/%3E%3Ccircle cx='80' cy='80' r='4' fill='%23f4cf4c'/%3E%3Ccircle cx='100' cy='110' r='4' fill='%23f4cf4c'/%3E%3Ccircle cx='120' cy='70' r='4' fill='%23f4cf4c'/%3E%3Ccircle cx='140' cy='90' r='4' fill='%23f4cf4c'/%3E%3Ccircle cx='160' cy='60' r='4' fill='%23f4cf4c'/%3E%3Ccircle cx='180' cy='120' r='4' fill='%23f4cf4c'/%3E%3C/svg%3E",
      tags: ['React Native', 'Redux', 'API Integration'],
      link: '#'
    },
    {
      id: 5,
      title: 'Pixel Art Gallery',
      description: 'A digital gallery showcasing pixel art with animation and interaction.',
      category: 'web',
      image: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='240' height='180' viewBox='0 0 240 180'%3E%3Crect width='240' height='180' fill='%23f5f5f5'/%3E%3Crect x='20' y='20' width='60' height='60' fill='%23cf56a1'/%3E%3Crect x='90' y='20' width='60' height='60' fill='%233da6a6'/%3E%3Crect x='160' y='20' width='60' height='60' fill='%23f4cf4c'/%3E%3Crect x='20' y='90' width='60' height='60' fill='%232d5d3b'/%3E%3Crect x='90' y='90' width='60' height='60' fill='%235ecc5e'/%3E%3Crect x='160' y='90' width='60' height='60' fill='%23e05c5c'/%3E%3C/svg%3E",
      tags: ['JavaScript', 'Canvas API', 'HTML5'],
      link: '#'
    },
    {
      id: 6,
      title: 'Dungeon Crawler',
      description: 'A roguelike dungeon crawler with procedurally generated levels.',
      category: 'game',
      image: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='240' height='180' viewBox='0 0 240 180'%3E%3Crect width='240' height='180' fill='%232a2a2a'/%3E%3Crect x='0' y='0' width='40' height='40' fill='%233d3d3d'/%3E%3Crect x='40' y='0' width='40' height='40' fill='%233d3d3d'/%3E%3Crect x='80' y='0' width='40' height='40' fill='%233d3d3d'/%3E%3Crect x='120' y='0' width='40' height='40' fill='%232a2a2a'/%3E%3Crect x='160' y='0' width='40' height='40' fill='%233d3d3d'/%3E%3Crect x='200' y='0' width='40' height='40' fill='%233d3d3d'/%3E%3Crect x='0' y='40' width='40' height='40' fill='%233d3d3d'/%3E%3Crect x='40' y='40' width='40' height='40' fill='%232a2a2a'/%3E%3Crect x='80' y='40' width='40' height='40' fill='%232a2a2a'/%3E%3Crect x='120' y='40' width='40' height='40' fill='%232a2a2a'/%3E%3Crect x='160' y='40' width='40' height='40' fill='%232a2a2a'/%3E%3Crect x='200' y='40' width='40' height='40' fill='%233d3d3d'/%3E%3Crect x='0' y='80' width='40' height='40' fill='%233d3d3d'/%3E%3Crect x='40' y='80' width='40' height='40' fill='%232a2a2a'/%3E%3Crect x='80' y='80' width='40' height='40' fill='%233da6a6'/%3E%3Crect x='120' y='80' width='40' height='40' fill='%232a2a2a'/%3E%3Crect x='160' y='80' width='40' height='40' fill='%232a2a2a'/%3E%3Crect x='200' y='80' width='40' height='40' fill='%233d3d3d'/%3E%3Crect x='0' y='120' width='40' height='40' fill='%233d3d3d'/%3E%3Crect x='40' y='120' width='40' height='40' fill='%232a2a2a'/%3E%3Crect x='80' y='120' width='40' height='40' fill='%232a2a2a'/%3E%3Crect x='120' y='120' width='40' height='40' fill='%233d3d3d'/%3E%3Crect x='160' y='120' width='40' height='40' fill='%233d3d3d'/%3E%3Crect x='200' y='120' width='40' height='40' fill='%233d3d3d'/%3E%3Crect x='0' y='160' width='40' height='20' fill='%233d3d3d'/%3E%3Crect x='40' y='160' width='40' height='20' fill='%233d3d3d'/%3E%3Crect x='80' y='160' width='40' height='20' fill='%233d3d3d'/%3E%3Crect x='120' y='160' width='40' height='20' fill='%233d3d3d'/%3E%3Crect x='160' y='160' width='40' height='20' fill='%233d3d3d'/%3E%3Crect x='200' y='160' width='40' height='20' fill='%233d3d3d'/%3E%3Ccircle cx='100' cy='100' r='10' fill='%23e05c5c'/%3E%3C/svg%3E",
      tags: ['Godot', 'GDScript', 'Procedural Generation'],
      link: '#'
    }
  ];
  
  const filteredProjects = activeFilter === 'all' 
    ? projects 
    : projects.filter(project => project.category === activeFilter);

  return (
    <section id="projects" className="py-20 relative">
      <div className="section-container">
        <h2 className="section-title text-white">My Projects</h2>
        
        {/* Category Filters */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {categories.map(category => (
            <button
              key={category.id}
              onClick={() => setActiveFilter(category.id)}
              className={cn(
                "pixel-btn py-2 px-4 text-xs",
                activeFilter === category.id 
                  ? "bg-forest text-white" 
                  : "bg-white/10 backdrop-blur-md text-white hover:bg-white/20"
              )}
            >
              {category.name}
            </button>
          ))}
        </div>
        
        {/* Project Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProjects.map(project => (
            <div
              key={project.id}
              className="pixel-card group hover:bg-white/20 bg-white/10 backdrop-blur-md"
            >
              <div className="relative overflow-hidden mb-4 aspect-[4/3] pixel-border">
                <img 
                  src={project.image} 
                  alt={project.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              
              <h3 className="font-pixel text-lg text-grass-light mb-2">{project.title}</h3>
              <p className="font-mono text-sm text-white/90 mb-4">{project.description}</p>
              
              <div className="flex flex-wrap gap-2 mb-4">
                {project.tags.map((tag, index) => (
                  <span 
                    key={index} 
                    className="inline-block font-mono text-xs px-2 py-1 bg-forest/40 text-white/80"
                  >
                    {tag}
                  </span>
                ))}
              </div>
              
              <a 
                href={project.link} 
                className="inline-block font-pixel text-xs text-grass hover:text-grass-light transition-colors"
              >
                View Project →
              </a>
            </div>
          ))}
        </div>
        
        {/* See More Button */}
        <div className="flex justify-center mt-12">
          <a href="#" className="pixel-btn bg-forest text-white hover:bg-forest-light">
            See All Projects
          </a>
        </div>
      </div>
    </section>
  );
};

export default Projects;